// test1399
(1399 && 0);
